import { useEffect } from 'react';
import useAppStore from '../../store/rootStore';
import { useHeartbeatStore } from '@/common/heartbeatStore.ts';
import { MarketID } from '@/api/spec.ts';

export function useFundingWatcher() {
  const markets = useAppStore((state) => state.markets);
  const applyFundingUpdate = useAppStore((state) => state.applyFundingUpdate);
  const headBlock = useHeartbeatStore((s) => s.marketData.headBlockNumber);

  useEffect(() => {
    if (headBlock == null) return;

    markets.forEach((market, marketId: MarketID) => {
      if (market.nextFundingBlock && headBlock >= market.nextFundingBlock) {
        applyFundingUpdate(headBlock, marketId);
      }
    });
  }, [headBlock, markets, applyFundingUpdate]);
}
